import script from "./label-text-section.vue?vue&type=script&setup=true&lang=js"
export * from "./label-text-section.vue?vue&type=script&setup=true&lang=js"

import "./label-text-section.vue?vue&type=style&index=0&id=b0498f50&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0498f50"]])

export default __exports__